import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "28.3",
  viewBox: "0 0 50 28.3",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M24.999 28.3 0 3.304 3.303 0l21.702 21.704L46.705.093 50 3.402Z"
  })]
});